
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'ArrowRight'
})
export default class ArrowRight extends Vue {}
